// Scrollspy für die Navigation auf Ratgeber-Seiten
const scrollspyNavigation = {
    init() {
        const observer = new IntersectionObserver((entries) => {
            // entries.forEach((entry) => {
            const entry = entries[0];
            const id = entry.target.getAttribute('id');
            const shouldBeActiveLink = document.querySelector(`.js-content-navigation a[href="#${id}"]`);
            const activeLink = document.querySelector('.js-content-navigation a.active');

            if (entry.intersectionRatio > 0) {
                shouldBeActiveLink.classList.add('active');

                if (activeLink && activeLink !== shouldBeActiveLink) {
                    activeLink.classList.remove('active');
                }
            }
            // });
        });

        const headlines = document.querySelectorAll('h2[id]');
        const contentNavigationLinks = document.querySelectorAll('.js-content-navigation a');

        if (headlines && contentNavigationLinks) {
            headlines.forEach((headline) => {
                observer.observe(headline);
            });

            if (contentNavigationLinks) {
                contentNavigationLinks.forEach((link) => {
                    link.addEventListener('click', (event) => {
                        const activeLink = document.querySelector('.js-content-navigation a.active');
                        if (activeLink) {
                            activeLink.classList.remove('active');
                        }

                        event.target.classList.add('active');
                    });
                });
            }
        }
    },
};

export default scrollspyNavigation;
